import React from 'react'
import PropTypes from 'prop-types'
import { SearchAltIcon } from 'components/icons'
import DestinationSelectionPopover from 'components/home/navbar/popovers/specific/DestinationSelectionPopover'
import Button from 'components/Button'
import ServiceCategorySelectionPopover from 'components/home/navbar/popovers/specific/ServiceCategorySelectionPopover'
import ServiceSearchPopover from 'components/home/navbar/popovers/specific/ServiceSearchPopover'

const ServiceSearchBarContent = ({
  searchAction = () => { },
  isLoading = false,
}) => {

  return (
    <>
      {/* Destination Dropdown */}
      <DestinationSelectionPopover
        placeholder="Choose Destinations"
        className={{
          panel: '!top-[calc(100%+2px)] mr-auto ml-0',
        }}
      />

      <div className="h-[48px] border-r-[1px] border-grey border-opacity-30" />

      <ServiceSearchPopover />

      <div className="h-[48px] border-r-[1px] border-grey border-opacity-30" />

      {/* Filters dropdown */}
      <ServiceCategorySelectionPopover
        className={{
          panel: 'top-[calc(100%+2px)]',
        }}
      />

      <div className="flex items-center ml-auto h-80">
        <Button
          className="h-full w-full !text-18 md:w-[64px] md:h-[34px] md:rounded-full gap-10 !p-0"
          onClick={searchAction}
          isLoading={isLoading}
          loadingClassName="p-8"
        >
          <SearchAltIcon />
          <p className="text-16 md:hidden">Search</p>
        </Button>
      </div>
    </>
  )
}

ServiceSearchBarContent.propTypes = {
  searchAction: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default ServiceSearchBarContent
